// Shared Kalpanamart Design System — import this in each page
export const KM_VARS = `
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');
    :root {
        --km-blue-deep:   #0C3D7A;
        --km-blue-mid:    #1A52A8;
        --km-blue-bright: #2563C8;
        --km-blue-light:  #DCEEFF;
        --km-blue-xl:     #EEF5FF;
        --km-orange:      #F57C00;
        --km-orange-l:    #FFF3E0;
        --km-green:       #3B8A3E;
        --km-green-l:     #E8F5E9;
        --km-red:         #E24B4A;
        --km-red-l:       #FFF3F3;
        --km-txt:         #0D1B36;
        --km-txt2:        #4A5578;
        --km-txt3:        #8A96B0;
        --km-bdr:         #C8DEFF;
        --km-w:           #FFFFFF;
        --km-r:           16px;
        --km-rs:          10px;
        --km-shadow:      0 4px 24px rgba(26,82,168,.10);
        --km-shadow-lg:   0 8px 40px rgba(12,61,122,.16);
    }
`;

export const KM_BASE = `
    .km-page {
        font-family: 'Plus Jakarta Sans', sans-serif;
        // background: linear-gradient(160deg, #EEF5FF 0%, #F8FBFF 60%, #FFFDF8 100%);
        min-height: 100vh;
        padding: 50px 0 80px;
    }
    .km-full { width: 100%; padding: 0 32px; box-sizing: border-box; }
    @media(max-width:768px){ .km-full { padding: 0 16px; } }

    /* ── Page Header ── */
    .km-ph { text-align: center; margin-bottom: 32px; }
    .km-brand-tag {
        display: inline-flex; align-items: center; gap: 7px;
        background: var(--km-blue-mid); color: #fff;
        border-radius: 20px; padding: 5px 14px 5px 7px;
        font-size: 11px; font-weight: 700; letter-spacing: .06em;
        text-transform: uppercase; margin-bottom: 10px;
    }
    .km-k { width: 22px; height: 22px; background: var(--km-orange); border-radius: 6px;
        display: flex; align-items: center; justify-content: center;
        font-size: 12px; font-weight: 800; color: #fff; }
    .km-ph h1 { font-size: 28px; font-weight: 700; color: var(--km-blue-deep); letter-spacing:-.02em; margin:0 0 5px; }
    .km-ph p  { font-size: 11px; color: var(--km-blue-mid); opacity:.7; font-weight: 600;
        letter-spacing: .1em; text-transform: uppercase; margin:0; }

    /* ── Cards ── */
    .km-card {
        background: var(--km-w); border: 1px solid var(--km-bdr);
        border-radius: var(--km-r); box-shadow: var(--km-shadow); overflow: hidden;
    }
    .km-card-hd {
        padding: 14px 24px;
        background: linear-gradient(90deg, var(--km-blue-deep) 0%, var(--km-blue-mid) 100%);
        display: flex; align-items: center; gap: 10px;
    }
    .km-ibadge {
        display: inline-flex; align-items: center; gap: 7px;
        background: rgba(255,255,255,.15); border: 1px solid rgba(255,255,255,.25);
        border-radius: 20px; padding: 4px 14px;
        font-size: 11px; font-weight: 700; color: #fff;
        letter-spacing: .06em; text-transform: uppercase;
    }
    .km-bdot { width: 7px; height: 7px; background: var(--km-orange); border-radius: 50%; box-shadow: 0 0 0 2px rgba(245,124,0,.3); }

    /* ── Table ── */
    .km-table-wrap { overflow-x: auto; }
    .km-table { width: 100%; border-collapse: collapse; }
    .km-table thead th {
        padding: 11px 16px; font-size: 10px; font-weight: 700;
        color: var(--km-blue-mid); text-transform: uppercase; letter-spacing: .08em;
        background: var(--km-blue-xl); border-bottom: 1px solid var(--km-bdr); white-space: nowrap;
    }
    .km-table tbody td {
        padding: 15px 16px; font-size: 13px; color: var(--km-txt);
        border-bottom: 1px solid var(--km-blue-xl); vertical-align: middle; transition: background .15s;
    }
    .km-table tbody tr:last-child td { border-bottom: none; }
    .km-table tbody tr:hover td { background: var(--km-blue-xl); }

    /* ── Product cell ── */
    .km-prod-cell { display: flex; align-items: center; gap: 12px; min-width: 180px; }
    .km-img-w {
        width: 52px; height: 52px; flex-shrink: 0;
        border-radius: 10px; border: 1.5px solid var(--km-bdr);
        background: var(--km-blue-xl); overflow: hidden;
        display: flex; align-items: center; justify-content: center;
    }
    .km-img-w img { width:100%; height:100%; object-fit:contain; padding:4px; }
    .km-pname {
        font-size: 13px; font-weight: 700; color: var(--km-blue-deep);
        text-decoration: none; display: block; margin-bottom: 3px; line-height:1.4;
        transition: color .15s;
    }
    .km-pname:hover { color: var(--km-orange); }
    .km-pmeta { font-size: 11px; color: var(--km-txt3); font-weight: 500; }

    /* ── Prices ── */
    .km-price   { font-size: 14px; font-weight: 700; color: var(--km-orange); white-space: nowrap; }
    .km-subtotal{ font-size: 14px; font-weight: 700; color: var(--km-blue-mid); white-space: nowrap; }

    /* ── Buttons ── */
    .km-rm-btn {
        width: 30px; height: 30px; border-radius: 8px;
        background: var(--km-blue-xl); border: 1px solid var(--km-bdr);
        color: var(--km-txt3); display: flex; align-items: center;
        justify-content: center; font-size: 13px; cursor: pointer; transition: all .18s;
    }
    .km-rm-btn:hover { background:#FFEAEA; border-color:var(--km-red); color:var(--km-red); transform:scale(1.05); }
    .km-btn-primary {
        display: inline-flex; align-items: center; gap: 8px;
        background: linear-gradient(135deg, var(--km-blue-mid) 0%, var(--km-blue-bright) 100%);
        color: #fff !important; border-radius: 50px; padding: 12px 28px;
        font-size: 13px; font-weight: 700; text-decoration: none; border: none;
        box-shadow: 0 4px 16px rgba(26,82,168,.35); transition: all .22s; cursor: pointer;
        font-family: inherit;
    }
    .km-btn-primary:hover { transform:translateY(-2px); box-shadow:0 8px 24px rgba(26,82,168,.45); color:#fff !important; }
    .km-btn-outline {
        display: inline-flex; align-items: center; gap: 8px;
        background: transparent; color: var(--km-blue-mid) !important;
        // border: 1.5px solid var(--km-blue-mid); border-radius: 50px;
        padding: 9px 20px; font-size: 12px; font-weight: 700;
        text-decoration: none; transition: all .18s; cursor: pointer; font-family: inherit;
    }
    .km-btn-outline:hover {  color:black !important; }
    .km-btn-orange {
        display: inline-flex; align-items: center; gap: 8px;
        background: var(--km-orange); color:#fff !important; border: none;
        border-radius: 50px; padding: 9px 20px; font-size: 12px; font-weight: 700;
        cursor: pointer; font-family: inherit; transition: all .18s; white-space: nowrap;
    }
    .km-btn-orange:hover { background:#e56500; transform:translateY(-1px); }
    .km-btn-orange.added { background: var(--km-green); pointer-events: none; }
    .km-btn-orange:disabled { background:#ccc; cursor:not-allowed; }

    /* ── Card footer ── */
    .km-card-ft { padding: 14px 24px; border-top: 1px solid var(--km-blue-xl);  }

    /* ── Summary sidebar ── */
    .km-sum-card {
        background: var(--km-w); border: 1px solid var(--km-bdr);
        border-radius: var(--km-r); box-shadow: var(--km-shadow-lg); overflow: hidden;
        position: sticky; top: 20px;
    }
    .km-sum-hd {
        background: linear-gradient(135deg, var(--km-blue-deep) 0%, var(--km-blue-bright) 100%);
        padding: 20px 22px 16px; position: relative; overflow: hidden;
    }
    .km-sum-hd::after  { content:''; position:absolute; bottom:-14px; right:-14px; width:70px; height:70px; border-radius:50%; background:rgba(255,255,255,.08); }
    .km-sum-hd::before { content:''; position:absolute; top:-20px; left:38%; width:100px; height:100px; border-radius:50%; background:rgba(255,255,255,.05); }
    .km-sum-title { font-size: 15px; font-weight: 700; color:#fff; margin:0 0 6px; position:relative; z-index:1; }
    .km-swoosh { height:3px; width:36px; background:var(--km-orange); border-radius:2px; }
    .km-sum-body { padding: 18px 22px 22px; }
    .km-srow {
        display: flex; justify-content: space-between; align-items: center;
        padding: 9px 0; font-size: 13px; color: var(--km-txt2);
        border-bottom: 1px dashed var(--km-blue-light);
    }
    .km-srow:last-of-type { border-bottom:none; }
    .km-sval { font-weight: 700; color: var(--km-txt); }
    .km-free-b {
        font-size: 11px; font-weight: 700; color: var(--km-green);
        background: var(--km-green-l); padding: 3px 10px;
        border-radius: 20px; border: 1px solid #A5D6A7;
    }
    .km-sdiv { border:none; border-top:2px solid var(--km-blue-light); margin:12px 0; }
    .km-total-row { display:flex; justify-content:space-between; align-items:center; margin-bottom:18px; }
    .km-total-lbl { font-size:15px; font-weight:700; color:var(--km-txt); }
    .km-total-val { font-size:24px; font-weight:700; color:var(--km-orange); letter-spacing:-.02em; }
    .km-checkout-btn {
        display: flex; align-items: center; justify-content: center; gap: 8px;
        width: 100%;
        background: linear-gradient(135deg, var(--km-blue-mid) 0%, var(--km-blue-bright) 100%);
        color: #fff !important; border: none; border-radius: 50px;
        padding: 14px 24px; font-size: 13px; font-weight: 700;
        text-decoration: none; letter-spacing: .02em;
        box-shadow: 0 4px 16px rgba(26,82,168,.35); cursor: pointer;
        font-family: inherit; transition: all .22s; margin-bottom: 10px;
    }
    .km-checkout-btn:hover { transform:translateY(-2px); box-shadow:0 8px 24px rgba(26,82,168,.45); color:#fff !important; }
    .km-trust { display:flex; justify-content:center; gap:14px; margin-top:4px; }
    .km-trust span { display:flex; align-items:center; gap:5px; font-size:11px; color:var(--km-txt3); font-weight:600; }

    /* ── Badges ── */
    .km-in  { color:var(--km-green); background:var(--km-green-l); padding:4px 10px; border-radius:6px; font-size:12px; font-weight:600; display:inline-flex; align-items:center; gap:6px; }
    .km-out { color:#A32D2D; background:var(--km-red-l); padding:4px 10px; border-radius:6px; font-size:12px; font-weight:600; display:inline-flex; align-items:center; gap:6px; }
    .km-din { width:6px; height:6px; background:var(--km-green); border-radius:50%; }
    .km-dout{ width:6px; height:6px; background:#A32D2D; border-radius:50%; }

    /* ── Empty state ── */
    .km-empty {
        background: var(--km-w); border: 1px solid var(--km-bdr);
        border-radius: 20px; padding: 72px 40px; text-align: center;
        box-shadow: var(--km-shadow); max-width: 520px; margin: 0 auto;
    }
    .km-empty-icon {
        width: 88px; height: 88px;
        background: linear-gradient(135deg, var(--km-blue-deep), var(--km-blue-bright));
        border-radius: 50%; display:flex; align-items:center; justify-content:center;
        margin: 0 auto 22px; font-size:36px; color:#fff;
        box-shadow: 0 8px 28px rgba(26,82,168,.3);
    }
    .km-empty h4 { font-size:22px; font-weight:700; color:var(--km-blue-deep); margin-bottom:8px; }
    .km-empty p  { font-size:14px; color:var(--km-txt2); margin-bottom:28px; }

    /* ── Loader ── */
    .km-loader { display:flex; flex-direction:column; align-items:center; justify-content:center; min-height:300px; gap:14px; }
    .km-spinner { width:44px; height:44px; border:3px solid var(--km-blue-light); border-top:3px solid var(--km-blue-mid); border-radius:50%; animation:km-spin .8s linear infinite; }
    @keyframes km-spin { to { transform:rotate(360deg); } }
    .km-loader p { font-size:13px; font-weight:600; color:var(--km-blue-mid); }

    /* ── Error ── */
    .km-err { background:var(--km-red-l); border:1px solid #F5C6C6; border-radius:10px; padding:10px 16px; font-size:13px; color:#A32D2D; margin-bottom:20px; }

    /* ── Qty control ── */
    .km-qc { display:inline-flex; align-items:center; gap:4px; }
    .km-qc-btn { width:26px; height:26px; border-radius:7px; border:1px solid var(--km-bdr); background:var(--km-blue-xl); color:var(--km-blue-mid); font-size:14px; cursor:pointer; display:flex; align-items:center; justify-content:center; font-weight:700; font-family:inherit; }
    .km-qc-num { width:30px; text-align:center; font-size:13px; font-weight:700; color:var(--km-txt); }

    /* ── Discount row ── */
    .km-disc-lbl { color:var(--km-green); font-weight:600; }
    .km-disc-val  { color:var(--km-green); font-weight:700; }
`;